export async function getFullSongIntegrationTokens() {
  const debug = useDebug();
  const profile = useProfileStore();
  debug.log("getting full song playback settings");
  await profile.profilePromise;

  let authInfo: any = null;
  let service: "apple" | "spotify" | null = null;
  if (
    profile.profile?.signedIn &&
    profile.profile?.musicPlayerPreferences.authInfo
  ) {
    authInfo = JSON.parse(profile.profile.musicPlayerPreferences.authInfo);
  }

  if (profile.profile?.musicPlayerPreferences.service) {
    service = profile.profile?.musicPlayerPreferences.service?.toLowerCase() as
      | "apple"
      | "spotify"
      | null;
  }

  return {
    authInfo,
    service,
  };
}
